const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const inputSelector = [
  "input:not([type='button']):not([type='checkbox']):not([type='color']):not([type='file']):not([type='image']):not([type='radio']):not([type='range']):not([type='reset']):not([type='submit'])",
  'select',
  'textarea',
].join(',');

if (isIOS) {
  let viewport = document.querySelector('meta[name="viewport"]');
  let initialContent = viewport?.getAttribute('content') || 'width=device-width,initial-scale=1';
  let restoreTimer;
  let isLocked = false;

  const getViewport = () => {
    viewport = viewport || document.querySelector('meta[name="viewport"]');

    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.setAttribute('name', 'viewport');
      viewport.setAttribute('content', initialContent);
      document.head.append(viewport);
    }

    return viewport;
  };

  const getLockedContent = (content) => {
    const directives = content
      .split(',')
      .map((directive) => directive.trim())
      .filter((directive) => directive)
      .filter((directive) => !directive.startsWith('maximum-scale='))
      .filter((directive) => !directive.startsWith('user-scalable='));

    directives.push('maximum-scale=1', 'user-scalable=no');

    return directives.join(',');
  };

  const shouldLockZoom = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (!element.matches(inputSelector)) return false;
    // A pinched-in user has already chosen their zoom level; locking now would snap them back to 1x.
    if (window.visualViewport && window.visualViewport.scale > 1) return false;

    const fontSize = Number.parseFloat(window.getComputedStyle(element).fontSize);

    return Number.isFinite(fontSize) && fontSize < 16;
  };

  const lockZoom = (element) => {
    if (!shouldLockZoom(element)) return;

    window.clearTimeout(restoreTimer);

    const activeViewport = getViewport();

    if (!isLocked) {
      initialContent = activeViewport.getAttribute('content') || initialContent;
    }

    activeViewport.setAttribute('content', getLockedContent(initialContent));
    isLocked = true;
  };

  const restoreZoom = (delay = 150) => {
    window.clearTimeout(restoreTimer);

    restoreTimer = window.setTimeout(() => {
      if (shouldLockZoom(document.activeElement)) return;

      getViewport().setAttribute('content', initialContent);
      isLocked = false;
    }, delay);
  };

  const resolveTouchedControl = (target) => {
    if (!(target instanceof Element)) return null;

    const touched = target.closest(`label,${inputSelector}`);

    if (touched) return touched instanceof HTMLLabelElement ? touched.control : touched;

    // Klaviyo's country/submit buttons focus a small input from their own handler.
    const embedButton = target.closest('cart-whatsapp-embed [data-whatsapp-embed] button');
    return embedButton?.closest('[data-whatsapp-embed]')?.querySelector('input[type="tel"], input[role="combobox"]');
  };

  const prepareFocusZoom = (event) => {
    if (event.type === 'touchstart' && event.touches.length > 1) return;

    lockZoom(resolveTouchedControl(event.target));
    if (isLocked) restoreZoom(1000);
  };

  // iOS commits to the focus zoom at tap time, before focusin fires, so the
  // viewport must already be locked when a tap lands on a small input. The
  // longer restore delay covers taps that never produce a focus (e.g. a touch
  // that turns into a scroll); a focus keeps the lock via the activeElement
  // check, an earlier blur shortens it back to the 150ms path.
  document.addEventListener(
    'touchstart',
    prepareFocusZoom,
    { capture: true, passive: true }
  );

  // Covers keyboard activation and refreshes the lock before Klaviyo handles a click.
  document.addEventListener('click', prepareFocusZoom, true);
  document.addEventListener('focusin', (event) => lockZoom(event.target), true);
  document.addEventListener('focusout', () => restoreZoom(), true);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      window.clearTimeout(restoreTimer);
      getViewport().setAttribute('content', initialContent);
      isLocked = false;
    }
  });
}
